module.exports = __webpack_public_path__ + "img/AB54A8_EBAAE9_DF8FDD_D37ED0-256px.2710e086.png";